import { render, staticRenderFns } from "./ShipmentDetail.vue?vue&type=template&id=ce988cf6&scoped=true&"
import script from "./ShipmentDetail.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetail.vue?vue&type=style&index=0&id=ce988cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce988cf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce988cf6')) {
      api.createRecord('ce988cf6', component.options)
    } else {
      api.reload('ce988cf6', component.options)
    }
    module.hot.accept("./ShipmentDetail.vue?vue&type=template&id=ce988cf6&scoped=true&", function () {
      api.rerender('ce988cf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/ShipmentDetail.vue"
export default component.exports